import API from '../../shared/Config/API';
import APIEndpoints from '../../shared/Config/APIEndpoints';

const fetchRegionStates = async (payload) => {
  try {
    return await API.get(APIEndpoints.STATES, payload, {
      'wantsDistricts.equals': true,
    });
  } catch (error) {
    console.error(error);
  }
};

export const regionAPI = {
  fetchRegionStates,
};
